import BaseExtension from './base';

import { createElement, addClass } from '../utils';

const CN = 'rmp-ext-poster';
const VIDEO_CN = `${CN}--video`;
const HIDDEN_CN = `${CN}--hidden`;

export default class PosterExtension extends BaseExtension {
   constructor(player, state, options) {
      super(player, state, options);
      this.logger.debug('poster:extension:creating');

      this._hidePoster = this._hidePoster.bind(this);
      this.render();

      this.logger.debug('poster:extension:created');
   }

   render() {
      this.$outer = createElement('div', { class: CN, tabindex: -1 });
      const img = createElement('img', { src: this.options.poster }, this.$outer);
      img.setAttribute('aria-label', this.options.title);
      if (!this.options.isAudio) {
         addClass(this.$outer, VIDEO_CN);
         this.bus.on('play', this._hidePoster);
      }
   }

   _hidePoster() {
      addClass(this.$outer, HIDDEN_CN);
   }

   getOuter() {
      return this.$outer;
   }

   destroy() {
      this.bus.off('play', this._hidePoster);
      super.destroy();
      if (this.$outer) {
         const parent = this.$outer.parentNode;
         parent.removeChild(this.$outer);
         this.$outer = null;
      }
   }
}
